/**
 * @desc 通过系统单号获取线下销售单信息
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(
  params: API.business.customerOrderFacadeImpl.getBySoOrderNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/customerOrder/getBySoOrderNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
